import dayjs from "dayjs";
import Image from "../../../Elements/Image/Image.tsx";
import config from "config";
import { useLightBox } from "../../../../contexts/lightBoxContext/lightBoxContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";

export const headerIcons = {
  Image: "image",
  Audio: "music-note",
  Video: "play",
  Zip: "zip",
  pdf: "pdf",
  Doc: "file",
  Other: "file",
  Folder: "folders",
};

const PasswordProtectedMobileItem = ({ wrapperClassName }) => {
  const { mobileCondition } = useMediaQueries();
  const { getTextByKey } = useContent();
  return (
    <div className={wrapperClassName + " pass-secured-mail"}>
      <Tooltip tooltipTextKey="split-info-password">
        <div className="single-item-preview disabled">
          <Image name="password-folder-box" ext="png" />
        </div>
        {mobileCondition && (
          <span className="pass-secured-info">
            {getTextByKey("split-info-password")}
          </span>
        )}
      </Tooltip>
    </div>
  );
};

const SingleItemComponent = ({ data, item }) => {
  const { setLightBox } = useLightBox();
  const { mobileCondition } = useMediaQueries();
  const { fetchMailFiles, setMetaDataProp, setFilesData } = useMail();
  const { getDirection } = useContent();

  const clickHandle = async (fileData, id) => {
    if (fileData.Type && fileData.mailStatus !== "removed") {
      /**
       * INBOX+MAILDATA
       * before open lightbox setting existing data to mailContext data
       * opening lightbox with existing filesData
       * after its doing the same request as downlaod page if files list more than 3
       * on response its replacing tempdata to the full
       */
      setFilesData(data.filesData);
      setLightBox(fileData.Type, id);
      setMetaDataProp("filesCount", data.filesQuantity);
      if (parseInt(data.filesQuantity) > 3) {
        fetchMailFiles({ mailId: data.id });
      }
    }
  };

  const fileData = data.filesData[item];
  const itemIcon =
    fileData.Type === "Doc"
      ? headerIcons[fileData.Extention] || headerIcons.Doc
      : headerIcons[fileData.Type] || "file";

  const componentToReturn = () => {
    return (
      <div
        className="single-item-preview"
        key={item}
        onClick={() => {
          clickHandle(fileData, item);
        }}
      >
        {fileData.Type === "Image" &&
        data.mailStatus !== "removed" &&
        fileData.ThumbSrc ? (
          <Image src={fileData.ThumbSrc} />
        ) : (
          <>
            <div className="inbox-item-icon">
              <Icon name={itemIcon} gray />
            </div>
            {itemIcon === "file" && (
              <span
                style={
                  mobileCondition
                    ? {
                        transform: `translate(${
                          getDirection() === "rtl" ? "25px" : "-20px"
                        })`,
                      }
                    : null
                }
                className={data.mailStatus === "removed" ? "removed-item" : ""}
              >
                {fileData.Extention}
              </span>
            )}
          </>
        )}
      </div>
    );
  };

  return mobileCondition ? (
    componentToReturn()
  ) : (
    <Tooltip id={item} tooltipText={fileData.Name}>
      {componentToReturn()}
    </Tooltip>
  );
};

const FilesPreviewComponent = ({ data }) => {
  const { getPath, getTextByKey } = useContent();

  const { mobileCondition } = useMediaQueries();

  const filesArray = data.filesData
    ? Object.keys(data.filesData).slice(0, 3)
    : [];

  const additionalClassName =
    data.filesQuantity === 1 || data.security?.isPasswordProtected
      ? "single-item"
      : data.filesQuantity === 3
      ? "triple-items"
      : "";

  const wrapperClassName = mobileCondition
    ? `mail-content ${additionalClassName}`
    : `gallery-items-section ${
        data.mailStatus === "removed" ? "removed-items" : ""
      }`;

  const IsJumboFormAndNotExpired =
    data.isJForm &&
    (!data.expirationDate || dayjs().isBefore(data.expirationDate));

  if (data.security?.isPasswordProtected) {
    return <PasswordProtectedMobileItem wrapperClassName={wrapperClassName} />;
  }

  const mobileReturn = () => (
    <>
      {filesArray.map((item, i) => {
        if (i < 1) {
          return <SingleItemComponent data={data} item={item} key={item} />;
        }
        if (i === 1) {
          return data.filesQuantity > 2 ? (
            <div
              className="single-item-preview all-items"
              onClick={() => {
                window.open(`${config.baseurl}${getPath()}gallery/${data.id}`);
              }}
              key={item}
            >
              <SingleItemComponent data={data} item={item} />
              <div className="files-more-quantity">
                +{data.filesQuantity - 2}
              </div>
            </div>
          ) : (
            <SingleItemComponent data={data} item={item} key={item} />
          );
        }
        return <></>;
      })}
    </>
  );

  return filesArray.length > 0 ? (
    <div className={wrapperClassName}>
      {mobileCondition ? (
        mobileReturn()
      ) : (
        <>
          {filesArray.map((item) => (
            <SingleItemComponent data={data} item={item} key={item} />
          ))}
          {data.filesQuantity > 3 ? (
            <Tooltip
              id={data.id + "morefiles"}
              tooltipTextKey={`tooltip-inbox-show-download-page`}
            >
              <div
                className="single-item-preview all-items"
                onClick={() => {
                  window.open(
                    `${config.baseurl}${getPath()}gallery/${data.id}`
                  );
                }}
              >
                <div>+{data.filesQuantity - 3}</div>
              </div>
            </Tooltip>
          ) : null}
        </>
      )}
    </div>
  ) : mobileCondition ? (
    IsJumboFormAndNotExpired ? (
      <PasswordProtectedMobileItem
        wrapperClassName={wrapperClassName + " single-item"}
      />
    ) : (
      <div className="files-expired-wrapper">
        <Image name="expired-mail" ext="svg" />
        <span>{getTextByKey("split-files-expired")}</span>
      </div>
    )
  ) : (
    <></>
  );
};

export default FilesPreviewComponent;
